<template>
  <client-only>
    <v-container class="agents-page">
      <div class="section_inner">
        <v-row class="agentHeader ma-0">
          <v-col>
            <AgentHeader :title="pageTitle" :text="pageSubTitle" />
          </v-col>
        </v-row>

        <AgentsList :agents-data="agentsData" v-if="!isLoading" />
        <Spinner v-if="isLoading" />
      </div>
      <!-- <div v-if="!isLoading">
        <InstructionsDialog
          :page="'agents'"
          :displayModal="ShowSmartAgentGuidAgentsPage"
        />
      </div>
      <InstructionBtn v-if="!isLoading" /> -->
      <FeedbackAgents
        v-if="this.CurrentUser && this.CurrentUser.ShowSmartAgentFeedback"
      />
    </v-container>
  </client-only>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
import AgentHeader from '@/components/Smart_Agent/Header/AgentHeader';
import AgentsList from '@/components/Japu/AgentsList';
// import InstructionsDialog from '@/components/Dialogs/InstructionsDialog/InstructionsDialog';
// import InstructionBtn from '@/components/Japu/Instructions/InstructionBtn';
import { USERAGENTS } from '@/lib/api.js';
import Spinner from '@/components/Spinner/Spinner';
import SeoOptimization from '@/components/mixins/SeoOptimization';

import FeedbackAgents from '@/components/Japu/FeedbackAgents/FeedbackAgents';

import CurrentUser from '@/components/mixins/CurrentUser';
import { mapGetters } from 'vuex';
export default {
  layout: 'personalFullWidth',
  name: 'smartalertsNotification',
  components: {
    AgentHeader,
    AgentsList,
    Spinner,
    // InstructionsDialog,
    // InstructionBtn,
    FeedbackAgents,
  },
  mixins: [SeoOptimization, CurrentUser],
  computed: {
    ...mapGetters(['CurrentUser']),
    isLoading() {
      return this.$fetchState.pending;
    },
  },
  data() {
    return {
      pageTitle: t`titles.candidates.smartAgentTitle`,
      pageSubTitle: t`titles.candidates.smartAgentListSub`,
      agentsData: null,
      seodata: null,
      isFilled: false,
    };
  },
  beforeDestroy() {
    this.agentsData = {};
  },

  async fetch() {
    await this.$auth.fetchUser();
    try {
      const { data } = await this.$axios.get(USERAGENTS);
      if (data.IsError) {
        throw 'שגיאה';
      }

      this.agentsData = data;
      this.seodata = {
        metaData: data.SEO.MetaDataItems,
        pageTitle: data.SEO.title,
        canonicalUrl: data.SEO.canonicalUrl,
      };
    } catch (e) {
      this.agentsData = {};
      console.log('res error smartalertsnotification', e);
    }
  },
  head() {
    return {
      title: 'רישום לסוכן החכם | דרושים IL',
      link: [
        {
          rel: 'canonical',
          href: 'https://www.drushim.co.il/smartalertsnotification',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.agents-page{
  min-height:500px
}
.conf-d {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: none;
  z-index: 5000;
}
</style>
